module.exports = __webpack_public_path__ + "img/logo.68367be2.svg";